/* =================================================================
   MontiPower Belt Selector — belt-selector.js
   Belt database, selector logic, chart, and popup open/close.
   ================================================================= */

(function () {
  'use strict';

  // ════════════════════════════════════════════════════════════════
  // CONFIGURATION — reads from mpbsConfig (WordPress admin) when
  // available; falls back to hardcoded defaults for standalone use.
  // ════════════════════════════════════════════════════════════════
  var _cfg = window.mpbsConfig || {};

  // ── BELT DATABASE — standard → substrate → grade → [tool, belt23mm, belt11mm]
  var DB = _cfg.db || {
    Sa2: {
      Steel:           { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Aluminium:       { "Grade 1 13-38µm":["BB","BB-102","BB-103"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Stainless Steel":{ "Grade 1 13-38µm":["BB","BB-102","BB-103"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Sheet Metal":   { "Grade 1 13-38µm":["MB","MB-001","MB-020"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Concrete:        { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] }
    },
    "Sa2 ½": {
      Steel:           { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Aluminium:       { "Grade 1 13-38µm":["MB","MB-011","MB-030"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Stainless Steel":{ "Grade 1 13-38µm":["BB","BB-102","BB-103"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Sheet Metal":   { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Concrete:        { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] }
    },
    Sa3: {
      Steel:           { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Aluminium:       { "Grade 1 13-38µm":["BB","BB-102","BB-103"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Stainless Steel":{ "Grade 1 13-38µm":["BB","BB-102","BB-103"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Sheet Metal":   { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Concrete:        { "Grade 1 13-38µm":["BB","BB-033","BB-034"], "Grade 2 25-64µm":["BB","BB-033","BB-034"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] }
    },
    St2: {
      Steel:           { "Grade 1 13-38µm":["MB","MB-001","MB-020"], "Grade 2 25-64µm":["MB","MB-001","MB-020"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Aluminium:       { "Grade 1 13-38µm":["MB","MB-011","MB-030"], "Grade 2 25-64µm":["MB","MB-011","MB-030"], "Grade 3 51-89µm":["MB","MB-011","MB-030"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Stainless Steel":{ "Grade 1 13-38µm":["MB","MB-011","MB-030"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Sheet Metal":   { "Grade 1 13-38µm":["MB","MB-009","MB-021"], "Grade 2 25-64µm":["MB","MB-009","MB-021"], "Grade 3 51-89µm":["MB","MB-001","MB-020"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Concrete:        { "Grade 1 13-38µm":["MB","MB-001","MB-020"], "Grade 2 25-64µm":["MB","MB-001","MB-020"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] }
    },
    St3: {
      Steel:           { "Grade 1 13-38µm":["MB","MB-001","MB-020"], "Grade 2 25-64µm":["MB","MB-001","MB-020"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Aluminium:       { "Grade 1 13-38µm":["MB","MB-011","MB-030"], "Grade 2 25-64µm":["MB","MB-011","MB-030"], "Grade 3 51-89µm":["MB","MB-011","MB-030"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Stainless Steel":{ "Grade 1 13-38µm":["MB","MB-011","MB-030"], "Grade 2 25-64µm":["BB","BB-102","BB-103"], "Grade 3 51-89µm":["BB","BB-102","BB-103"], "Grade 4 75-127µm":["BB","BB-102","BB-103"], "Grade 5 102-152µm":["BB","BB-102","BB-103"] },
      "Sheet Metal":   { "Grade 1 13-38µm":["MB","MB-009","MB-021"], "Grade 2 25-64µm":["MB","MB-009","MB-021"], "Grade 3 51-89µm":["MB","MB-001","MB-020"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] },
      Concrete:        { "Grade 1 13-38µm":["MB","MB-001","MB-020"], "Grade 2 25-64µm":["MB","MB-001","MB-020"], "Grade 3 51-89µm":["BB","BB-033","BB-034"], "Grade 4 75-127µm":["BB","BB-033","BB-034"], "Grade 5 102-152µm":["BB","BB-033","BB-034"] }
    }
  }; // end DB fallback

  // ── SSPC / NACE aliases → ISO keys
  // Note: SP7 (Brush-Off / Sa1) has no lower DB entry.
  //       Resolves to Sa2 as minimum achievable with Montipower tools.
  var ALIASES = {
    "SSPC-SP2":"St2","SSPC-SP3":"St3","SSPC-SP5":"Sa3","SSPC-SP6":"Sa2",
    "SSPC-SP7":"Sa2","SSPC-SP10":"Sa2 ½","SSPC-SP11":"Sa2 ½",
    "Nace#1":"Sa3","Nace#2":"Sa2 ½","Nace#3":"Sa2","Nace#4":"Sa2"
  };

  // ── BELT INFO — keyed by internal belt code
  var BELT_INFO = _cfg.beltInfo || {
    // Bristle Blaster® — standard belts
    "BB-033": { article:"BB-033",    name:"Bristle Blaster® Steel",                 color:"#FF1212", label:"Red — Steel, 23 mm" },
    "BB-034": { article:"BB-034",    name:"Bristle Blaster® Steel",                 color:"#FF1212", label:"Red — Steel, 11 mm" },
    "BB-102": { article:"BB-102",    name:"Bristle Blaster® Stainless Steel",       color:"#FF1212", label:"Red — Stainless Steel / Aluminium, 23 mm" },
    "BB-103": { article:"BB-103",    name:"Bristle Blaster® Stainless Steel",       color:"#FF1212", label:"Red — Stainless Steel / Aluminium, 11 mm" },
    // Bristle Blaster® — Axial belts (right + left pairs, 11 mm only)
    "BB-098R":{ article:"BB-098R",   name:"Bristle Blaster® Axial Steel",           color:"#FF1212", label:"Red — Axial Steel, 11 mm right" },
    "BB-099L":{ article:"BB-099L",   name:"Bristle Blaster® Axial Steel",           color:"#FF1212", label:"Red — Axial Steel, 11 mm left" },
    "BB-108R":{ article:"BB-108R",   name:"Bristle Blaster® Axial Stainless Steel", color:"#FF1212", label:"Red — Axial Stainless Steel, 11 mm right" },
    "BB-109L":{ article:"BB-109L",   name:"Bristle Blaster® Axial Stainless Steel", color:"#FF1212", label:"Red — Axial Stainless Steel, 11 mm left" },
    // MBX® belts — all packs of 10
    "MB-001": { article:"MB-001-10", name:"MBX® Coarse Black",                      color:"#222222", label:"Black — Coarse, Coating removal, 23 mm" },
    "MB-005": { article:"MB-005-10", name:"MBX® Fine Green",                        color:"#2E7D32", label:"Green — Fine, Cleaning, 23 mm" },
    "MB-007": { article:"MB-007-10", name:"MBX® Stainless Blue Fine",               color:"#1565C0", label:"Blue — Stainless / Aluminium, Fine, 23 mm" },
    "MB-009": { article:"MB-009-10", name:"MBX® Medium Ochre",                      color:"#CC7722", label:"Ochre — Medium, Derusting, 23 mm" },
    "MB-011": { article:"MB-011-10", name:"MBX® Stainless Blue Coarse",             color:"#1565C0", label:"Blue — Stainless / Aluminium, Coarse, 23 mm" },
    "MB-020": { article:"MB-020-10", name:"MBX® Coarse Black",                      color:"#222222", label:"Black — Coarse, Coating removal, 11 mm" },
    "MB-021": { article:"MB-021-10", name:"MBX® Medium Ochre",                      color:"#CC7722", label:"Ochre — Medium, Derusting, 11 mm" },
    "MB-028": { article:"MB-028-10", name:"MBX® Fine Green",                        color:"#2E7D32", label:"Green — Fine, Cleaning, 11 mm" },
    "MB-030": { article:"MB-030-10", name:"MBX® Stainless Blue Coarse",             color:"#1565C0", label:"Blue — Stainless / Aluminium, Coarse, 11 mm" },
    "MB-031": { article:"MB-031-10", name:"MBX® Stainless Blue Fine",               color:"#1565C0", label:"Blue — Stainless / Aluminium, Fine, 11 mm" }
  };

  // ── BELT LINKS — product page URL per tool code
  var BELT_LINKS = _cfg.beltLinks || {
    BB: '/collections/bristle-blaster-belts',
    MB: '/collections/mbx-belts'
  };

  // ── TOOL DATA — name, description, models, adapter interval
  var TOOL_DATA = _cfg.toolData || {
    BB: {
      name: "Bristle Blaster®",
      desc: "Wire-tip impact technology that creates surface profile and cleanliness in one pass. Complies with SSPC-SP11.",
      models: [
        { code:"SP-647-BMC", name:"Bristle Blaster® Pneumatic" },
        { code:"SE-670-BMC", name:"Bristle Blaster® Electric" },
        { code:"SB-600-BMC", name:"Bristle Blaster® Cordless" },
        { code:"Axial",      name:"Bristle Blaster® Axial (90° angles)" }
      ],
      adapterInterval: 30
    },
    MB: {
      name: "MBX® Metal Blaster",
      desc: "Coated abrasive belt system for derusting and profiling. Pneumatic version enables fast belt resharpening via the reverse button.",
      models: [
        { code:"SP-201-BMC", name:"MBX® Pneumatic (+ easy resharpen)" },
        { code:"SE-206-BMC", name:"MBX® Electric" },
        { code:"SB-200-BMC", name:"MBX® Cordless" },
        { code:"Axial",      name:"MBX® Axial (confined spaces)" }
      ],
      adapterInterval: 60
    }
  };

  // ── CTAs — labels and URLs from admin settings
  var CTAS = _cfg.ctas || {
    orderLabel:       'Order Belts',
    orderUrl:         '/collections/bristle-blaster-belts',
    supportEmail:     'info@montipower.com',
    distributorLabel: 'Find your distributor',
    distributorUrl:   'https://montipower.com/service-support/distributeurs/',
    quoteLabel:       'Request a quote',
    quoteUrl:         'https://montipower.com/service-support/request-for-quotation/',
    hsFormTitle:      'Get a Quote for This Belt Package',
    hsFormSubtitle:   'Your selection is included automatically — our team can prepare a tailored offer.'
  };

  // Viability data (Graph sheet rows 19-21, 70 data points per tool)
  var VIABILITY = {
    BB:[130,125,125,124,124,120,120,120,120,120,120,120,120,120,120,118,117,116,116,115,115,114,114,113,110,105,104,103,102,100,99,99,98,98,97,96,95,94,93,92,91,90,89,88,87,86,85,84,83,82,81,79,78,77,75,72,68,63,58,54,50,49,49,49,48,48,48,47,46,45],
    MB:[120,118,116,114,112,110,107,103,98,92,85,75,71,68,68,68,68,68,68,68,68,68,68,68,68,68,68,68,68,67,66,65,63,61,58,55,55,55,55,55,54,53,52,51,50,49,48,47,46,39,38,37,36,34,32,30,28,26,24,21,19,17,16,16,15,13,12,12,10,8]
  };

  // Grade number → full grade key (used by URL param reader)
  var GRADE_KEYS = {
    '1': 'Grade 1 13-38µm',
    '2': 'Grade 2 25-64µm',
    '3': 'Grade 3 51-89µm',
    '4': 'Grade 4 75-127µm',
    '5': 'Grade 5 102-152µm'
  };

  // Substrate URL param → display name
  var SUB_DECODE = {
    'Steel': 'Steel',
    'StainlessSteel': 'Stainless Steel',
    'Aluminium': 'Aluminium',
    'SheetMetal': 'Sheet Metal',
    'Concrete': 'Concrete'
  };

  // ── HUBSPOT config — reads from mpbsConfig, falls back to hardcoded defaults
  var HS_PORTAL_ID = _cfg.hsPortalId || '145604569';
  var HS_FORM_ID   = _cfg.hsFormId   || '26b984b3-4135-4e58-8ad2-b7333100010d';

  // ─── STATE ────────────────────────────────────────────────────────────────
  var state = { standard: null, substrate: null, grade: null };
  var mpChart = null;

  // ─── HUBSPOT TRACKING HELPERS ─────────────────────────────────────────────
  //
  // mpTrackOpen()  — fires on button click (existing behaviour, trackEvent)
  // mpTrackStep()  — fires on each selection with custom behavioral event +
  //                  properties so HubSpot reports show which values are chosen.
  //
  // Custom behavioral events require Marketing Hub Professional+.
  // Create the events in HubSpot: Reports → Analytics Tools → Custom Events.
  //   belt_standard_selected  (properties: standard, sspc_equiv)
  //   belt_substrate_selected (properties: substrate, standard)
  //   belt_grade_selected     (properties: grade, standard, substrate)
  //
  // Override event names via wp-config.php (see plugin PHP constants).

  function mpTrackOpen() {
    try { if(window.mpTrack) window.mpTrack('belt_selector_start',{}); } catch(e){}
    try {
      var _hsq = window._hsq = window._hsq || [];
      var id = _cfg.hsEventId || 'belt_selector_opened';
      _hsq.push(['trackEvent', { id: id }]);
    } catch (e) {}
  }

  function mpTrackStep(eventName, props) {
    try { if(window.mpTrack) window.mpTrack('belt_selector_step',{step:eventName}); } catch(e){}
    try {
      var _hsq = window._hsq = window._hsq || [];
      var pid = HS_PORTAL_ID;
      // trackCustomBehavioralEvent sends the value of each property to HubSpot
      _hsq.push(['trackCustomBehavioralEvent', {
        name: 'pe' + pid + '_' + eventName,
        properties: props || {}
      }]);
    } catch (e) {}
  }

  // ─── SESSION MEMORY ───────────────────────────────────────────────────────
  //
  // Persists the user's selections for the duration of the browser session
  // (cleared when the tab is closed).  On re-open the popup resumes from
  // the step the user last reached without losing their choices.

  var SESSION_KEY = 'mpbs_state';

  function mpSaveSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify({
        standard:  state.standard,
        substrate: state.substrate,
        grade:     state.grade
      }));
    } catch (e) {}
  }

  function mpClearSession() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  function mpRestoreSession() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (!s || !s.standard) return;

      state.standard  = s.standard;
      state.substrate = s.substrate || null;
      state.grade     = s.grade     || null;

      // Re-apply visual selected state on option cards
      var stdEl = document.getElementById('opt-' + state.standard.replace(/\s/g, ''));
      if (stdEl) stdEl.classList.add('selected');

      if (state.substrate) {
        var subEl = document.getElementById('sub-' + state.substrate.replace(/\s/g, ''));
        if (subEl) subEl.classList.add('selected');
        var notice = document.getElementById('ssNotice');
        if (notice) {
          if (state.substrate === 'Stainless Steel') notice.classList.add('visible');
          else notice.classList.remove('visible');
        }
      }

      if (state.grade) {
        var gradeEl = document.getElementById('grade-' + state.grade.split(' ')[1]);
        if (gradeEl) gradeEl.classList.add('selected');
      }

      // Jump to the furthest completed step
      if (state.grade)     showStep(4);
      else if (state.substrate) showStep(3);
      else                 showStep(2);

    } catch (e) {}
  }

  // ─── POPUP ────────────────────────────────────────────────────────────────
  var mpBsLastFocus = null;
  window.mpBsOpen = function () {
    var overlay = document.getElementById('mp-bs-overlay');
    if (!overlay) return;
    // Move overlay to <body> so its z-index reliably sits above the sticky header
    // (the header's backdrop-filter creates a stacking context that can otherwise trap it).
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.classList.add('mp-bs-active');
    if (!overlay.classList.contains('mp-bs-inline')) { if(window.mpOverlay){window.mpOverlay.open('belt',window.mpBsClose);}else{document.body.style.overflow='hidden';} }
    mpTrackOpen();
    mpRestoreSession();
    // Focus management (2.4.3): remember what opened the dialog, move focus inside it,
    // and only for the actual modal (button trigger), not the inline-embedded variant.
    if (!overlay.classList.contains('mp-bs-inline')) {
      mpBsLastFocus = document.activeElement;
      var closeBtn = overlay.querySelector('.mp-bs-close');
      if (closeBtn) closeBtn.focus();
    }
  };

  window.mpBsClose = function () {
    var overlay = document.getElementById('mp-bs-overlay');
    if (!overlay) return;
    overlay.classList.remove('mp-bs-active');
    if(window.mpOverlay){window.mpOverlay.close('belt');}else{document.body.style.overflow='';}
    if (mpBsLastFocus && typeof mpBsLastFocus.focus === 'function') {
      mpBsLastFocus.focus();
    }
    mpBsLastFocus = null;
  };

  // Init: backdrop close, ESC key, and URL-param auto-load (shareable links)
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('mp-bs-overlay');
    if (!overlay) return;

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) window.mpBsClose();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('mp-bs-active') && !overlay.classList.contains('mp-bs-inline')) window.mpBsClose();
    });

    // Auto-open from shareable URL params: ?belt_std=Sa2 ½&belt_sub=Steel&belt_grade=3
    try {
      var params = new URLSearchParams(window.location.search);
      var pStd   = params.get('belt_std');
      var pSub   = params.get('belt_sub');
      var pGrade = params.get('belt_grade');
      if (pStd && pSub && pGrade && GRADE_KEYS[pGrade] && SUB_DECODE[pSub]) {
        state.standard = pStd;
        state.substrate = SUB_DECODE[pSub];
        state.grade = GRADE_KEYS[pGrade];
        window.mpBsOpen();
        showStep(4);
      }
    } catch (e) {}
  });

  // ─── NAVIGATION ──────────────────────────────────────────────────────────
  window.goToStep = function (n) {
    if (n === 1 ||
        (n === 2 && state.standard) ||
        (n === 3 && state.standard && state.substrate)) {
      showStep(n);
    }
  };

  function showStep(n) {
    document.querySelectorAll('.step-panel').forEach(function (p) {
      p.classList.remove('active');
    });
    document.getElementById('step-' + n).classList.add('active');
    for (var i = 1; i <= 4; i++) {
      var el = document.getElementById('prog-' + i);
      if (!el) continue;
      el.classList.remove('active', 'done');
      el.removeAttribute('aria-current');
      if (i < n) el.classList.add('done');
      else if (i === n) { el.classList.add('active'); el.setAttribute('aria-current', 'step'); }
    }
    /* MOB-012: keep the active step visible in the horizontally-scrollable step row */
    var activeTab = document.getElementById('prog-' + n);
    if (activeTab && activeTab.scrollIntoView) { try { activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (_) { activeTab.scrollIntoView(); } }
    var modal = document.querySelector('.mp-bs-modal');
    if (modal) modal.scrollTop = 0;
    if (n === 4) setTimeout(renderResult, 50);
  }

  // ─── STEP 1 — STANDARD ──────────────────────────────────────────────────
  window.selectStandard = function (code) {
    state.standard = code;
    // Clear downstream selections when standard changes
    state.substrate = null;
    state.grade     = null;
    document.querySelectorAll('[id^="sub-"],[id^="grade-"]').forEach(function (e) {
      e.classList.remove('selected');
      e.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('[id^="opt-"]').forEach(function (e) {
      e.classList.remove('selected');
      e.setAttribute('aria-pressed', 'false');
    });
    var el = document.getElementById('opt-' + String(code).replace(/\s/g, ''));
    if (el) { el.classList.add('selected'); el.setAttribute('aria-pressed', 'true'); }
    mpSaveSession();
    var SSPC_MAP = { Sa2:'SSPC-SP6', 'Sa2 ½':'SSPC-SP10', Sa3:'SSPC-SP5', St2:'SSPC-SP2', St3:'SSPC-SP3' };
    mpTrackStep('belt_standard_selected', {
      standard:   code,
      sspc_equiv: SSPC_MAP[code] || ''
    });
    setTimeout(function () { showStep(2); }, 200);
  };

  window.toggleRef = function () {
    var p = document.getElementById('refPanel');
    if (!p) return;
    p.classList.toggle('open');
    var btn = document.querySelector('.ref-toggle-btn');
    if (btn) btn.setAttribute('aria-expanded', p.classList.contains('open') ? 'true' : 'false');
    if (p.classList.contains('open')) {
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg> Hide Reference';
    } else {
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg> Standards Reference';
    }
  };

  // ─── STEP 2 — SUBSTRATE ──────────────────────────────────────────────────
  window.selectSubstrate = function (sub) {
    state.substrate = sub;
    state.grade     = null;   // reset downstream
    document.querySelectorAll('[id^="grade-"]').forEach(function (e) {
      e.classList.remove('selected');
      e.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('[id^="sub-"]').forEach(function (e) {
      e.classList.remove('selected');
      e.setAttribute('aria-pressed', 'false');
    });
    var subEl = document.getElementById('sub-' + sub.replace(/\s/g, ''));
    subEl.classList.add('selected');
    subEl.setAttribute('aria-pressed', 'true');
    var notice = document.getElementById('ssNotice');
    if (notice) {
      if (sub === 'Stainless Steel') {
        notice.classList.add('visible');
      } else {
        notice.classList.remove('visible');
      }
    }
    mpSaveSession();
    mpTrackStep('belt_substrate_selected', {
      substrate: sub,
      standard:  state.standard
    });
    setTimeout(function () { showStep(3); }, 200);
  };

  // ─── STEP 3 — GRADE ──────────────────────────────────────────────────────
  window.selectGrade = function (grade) {
    state.grade = grade;
    document.querySelectorAll('[id^="grade-"]').forEach(function (e) {
      e.classList.remove('selected');
      e.setAttribute('aria-pressed', 'false');
    });
    var gradeEl = document.getElementById('grade-' + grade.split(' ')[1]);
    gradeEl.classList.add('selected');
    gradeEl.setAttribute('aria-pressed', 'true');
    mpSaveSession();
    mpTrackStep('belt_grade_selected', {
      grade:     grade.split(' ')[1],  // just the number, e.g. "3"
      standard:  state.standard,
      substrate: state.substrate
    });
    setTimeout(function () { showStep(4); }, 200);
  };

  // ─── RESULT ──────────────────────────────────────────────────────────────
  function renderResult() {
    var stdKey = state.standard;
    if (ALIASES[stdKey]) stdKey = ALIASES[stdKey];

    var rec = DB[stdKey] && DB[stdKey][state.substrate] && DB[stdKey][state.substrate][state.grade];
    if (!rec) {
      document.getElementById('result-content').innerHTML =
        '<p style="padding:24px;font-family:Archivo,sans-serif;color:#777;">No belt match found for this combination. Please contact Montipower for a custom recommendation.</p>';
      return;
    }

    var toolCode = rec[0], b23 = rec[1], b11 = rec[2];
    var tool  = TOOL_DATA[toolCode];
    if (!tool) {
      document.getElementById('result-content').innerHTML =
        '<p style="padding:24px;font-family:Archivo,sans-serif;color:#777;">Tool data unavailable for code "' + toolCode + '". Please check plugin settings.</p>';
      return;
    }
    var bi23  = BELT_INFO[b23] || {};
    var bi11  = BELT_INFO[b11] || {};
    try{ if(window.mpTrack) window.mpTrack('belt_selector_result',{recommended_tool:toolCode,belt:b23,substrate:state.substrate,standard:state.standard,grade:state.grade}); }catch(e){}
    var gradeNum = state.grade.split(' ')[1];
    var gradeMu  = state.grade.replace('Grade ' + gradeNum + ' ', '');

    // Aluminium always needs stainless bar; also detect by belt article
    var isStainless = (state.substrate === 'Stainless Steel' ||
                       state.substrate === 'Aluminium' ||
                       b23.indexOf('102') !== -1 ||
                       b23.indexOf('103') !== -1);

    var STD_LABEL  = { Sa2:'Sa 2', 'Sa2 ½':'Sa2 ½', Sa3:'Sa 3', St2:'St 2', St3:'St 3' };
    var SSPC_LABEL = { Sa2:'SSPC-SP6', 'Sa2 ½':'SSPC-SP10', Sa3:'SSPC-SP5', St2:'SSPC-SP2', St3:'SSPC-SP3' };
    var stdLabel  = STD_LABEL[stdKey]  || state.standard;
    var sspcLabel = SSPC_LABEL[stdKey] || '';

    var modelTags = tool.models.map(function (m) {
      return '<div style="margin-bottom:6px;"><span class="tool-model-tag">' + m.code + '</span>' +
             '<span style="font-size:12px;font-weight:300;color:#666;">' + m.name + '</span></div>';
    }).join('');

    // Axial belt section — only for Bristle Blaster, keyed by stainless/steel substrate
    var axialSection = '';
    if (toolCode === 'BB') {
      var axR   = isStainless ? 'BB-108R' : 'BB-098R';
      var axL   = isStainless ? 'BB-109L' : 'BB-099L';
      var biAxR = BELT_INFO[axR] || {};
      var biAxL = BELT_INFO[axL] || {};
      axialSection =
        '<div class="section-label">Bristle Blaster\xae Axial Belt Range</div>' +
        '<div class="alert-strip alert-info" style="margin-bottom:16px;"><div class="alert-text-wrap">' +
          '<div class="alert-label">For Bristle Blaster\xae Axial Only</div>' +
          '<div class="alert-body">The belts below are <strong>exclusively for the Bristle Blaster\xae Axial</strong> model. ' +
          'They are 11\xa0mm wide and come in a right-hand (R) and left-hand (L) version to match the rotation direction of your tool.</div>' +
        '</div></div>' +
        '<div class="belt-grid">' +
          '<div class="belt-card">' +
            '<div class="belt-color-bar" style="background:' + (biAxR.color || '#CC0000') + '"></div>' +
            '<div class="belt-card-inner">' +
              '<span class="belt-size">11\xa0mm — Right-hand (R)</span>' +
              '<div class="belt-article">' + (biAxR.article || axR) + '</div>' +
              '<div class="belt-name">' + (biAxR.name || axR) + '</div>' +
              '<div class="belt-color-label">' + (biAxR.label || '') + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="belt-card">' +
            '<div class="belt-color-bar" style="background:' + (biAxL.color || '#CC0000') + '"></div>' +
            '<div class="belt-card-inner">' +
              '<span class="belt-size">11\xa0mm — Left-hand (L)</span>' +
              '<div class="belt-article">' + (biAxL.article || axL) + '</div>' +
              '<div class="belt-name">' + (biAxL.name || axL) + '</div>' +
              '<div class="belt-color-label">' + (biAxL.label || '') + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    var acceleratorAlert = isStainless
      ? '<div class="alert-strip alert-blue"><div class="alert-text-wrap">' +
          '<div class="alert-label">Stainless Steel Accelerator Bar Required</div>' +
          '<div class="alert-body">Use the dedicated <strong>Stainless Steel Accelerator Bar</strong> with all stainless / aluminium belts. ' +
          'Never mix CS and stainless bars — iron particle contamination will cause rouge and surface corrosion.</div>' +
        '</div></div>'
      : '<div class="alert-strip alert-info"><div class="alert-text-wrap">' +
          '<div class="alert-label">Carbon Steel Accelerator Bar</div>' +
          '<div class="alert-body">Use the <strong>Carbon Steel Accelerator Bar</strong> for CS belts. ' +
          'Keep dedicated bars for CS and stainless work and label them clearly to prevent cross-contamination.</div>' +
        '</div></div>';

    document.getElementById('result-content').innerHTML =
      '<div class="result-banner">' +
        '<div>' +
          '<div class="result-banner-label">Belt Selection — EN ISO 8501-1 · SSPC-SP11</div>' +
          '<div class="result-banner-title">' + tool.name + '</div>' +
          '<div class="result-banner-meta">' +
            'Standard: <strong>' + stdLabel + '</strong>' + (sspcLabel ? ' · <strong>' + sspcLabel + '</strong>' : '') +
            ' &nbsp;·&nbsp; Material: <strong>' + state.substrate + '</strong>' +
            ' &nbsp;·&nbsp; Profile: <strong>Grade ' + gradeNum + '</strong> (' + gradeMu + ')' +
          '</div>' +
        '</div>' +
        '<div class="result-banner-arrow">›</div>' +
      '</div>' +

      '<div class="section-label" style="margin-top:0;">Recommended Tool</div>' +
      '<div class="tool-section">' +
        '<div class="tool-card">' +
          '<div class="tool-card-head">Recommended Machine</div>' +
          '<div class="tool-card-body">' +
            '<div class="tool-name">' + tool.name.replace('®', '<span>®</span>') + '</div>' +
            '<div class="tool-desc">' + tool.desc + '</div>' +
            '<div style="font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:8px;">Available Models</div>' +
            modelTags +
          '</div>' +
        '</div>' +
        '<div class="tool-card">' +
          '<div class="tool-card-head">Adapter &amp; Maintenance</div>' +
          '<div class="tool-card-body">' +
            '<div style="font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:10px;">Adapter Change Interval</div>' +
            '<div style="font-size:36px;font-weight:800;color:#FF1212;line-height:1;">' + tool.adapterInterval + '</div>' +
            '<div style="font-size:12px;font-weight:300;color:#777;margin-bottom:16px;">belts per adapter — then replace</div>' +
            '<div style="font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:8px;">Resharpening</div>' +
            '<div style="font-size:12px;font-weight:300;color:#666;line-height:1.6;">' +
              'Resharpen used belts in <strong style="color:#0c0c0c;">20 seconds</strong> with resharpening stone.' +
              (toolCode === 'MB' ? '<br>MBX® Pneumatic: use the <strong style="color:#0c0c0c;">reverse button</strong> for in-situ resharpening.' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="section-label">Recommended Belts</div>' +
      '<div class="belt-grid">' +
        '<div class="belt-card">' +
          '<div class="belt-color-bar" style="background:' + (bi23.color || '#888') + '"></div>' +
          '<div class="belt-card-inner">' +
            '<span class="belt-size">23 mm</span>' +
            '<div class="belt-article">' + (bi23.article || b23) + '</div>' +
            '<div class="belt-name">' + (bi23.name || b23) + '</div>' +
            '<div class="belt-color-label">' + (bi23.label || '') + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="belt-card">' +
          '<div class="belt-color-bar" style="background:' + (bi11.color || '#888') + '"></div>' +
          '<div class="belt-card-inner">' +
            '<span class="belt-size">11 mm — Tight Spaces</span>' +
            '<div class="belt-article">' + (bi11.article || b11) + '</div>' +
            '<div class="belt-name">' + (bi11.name || b11) + '</div>' +
            '<div class="belt-color-label">' + (bi11.label || '') + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div style="font-size:11px;font-weight:300;color:#888;margin-top:-16px;margin-bottom:24px;">' +
        '11\xa0mm belts are designed for tight spaces and hard-to-reach areas.' +
      '</div>' +

      axialSection +

      '<div class="section-label">Alerts &amp; Maintenance Requirements</div>' +
      '<div class="alerts">' +
        '<div class="alert-strip"><div class="alert-text-wrap">' +
          '<div class="alert-label">Adapter Change — Every ' + tool.adapterInterval + ' Belts</div>' +
          '<div class="alert-body">Replace the adapter after every <strong>' + tool.adapterInterval + ' belt uses</strong>. ' +
          'Worn adapters reduce performance, cause uneven wear, and can damage the drive unit. ' +
          'Rule of thumb: <strong>' + (TOOL_DATA.BB ? TOOL_DATA.BB.adapterInterval : 30) + ' belts</strong> for Bristle Blaster® · <strong>' + (TOOL_DATA.MB ? TOOL_DATA.MB.adapterInterval : 60) + ' belts</strong> for MBX® Metal Blaster.</div>' +
        '</div></div>' +
        '<div class="alert-strip alert-info"><div class="alert-text-wrap">' +
          '<div class="alert-label">Resharpening Stone — Extend Belt Life</div>' +
          '<div class="alert-body">Belts can be resharpened and <strong>re-used</strong> using the resharpening stone — just 20 seconds in reverse. ' +
          'With <strong>MBX® Pneumatic</strong>: engage the reverse button for fast in-situ resharpening.</div>' +
        '</div></div>' +
        acceleratorAlert +
        '<div class="alert-strip alert-success"><div class="alert-text-wrap">' +
          '<div class="alert-label">Belt Recycling Programme</div>' +
          '<div class="alert-body">Montipower <strong>recycling bins</strong> are recommended for collection of used belts. ' +
          'Used belts can be recycled — reducing CO₂ emissions and waste in line with Montipower\'s sustainability commitments.</div>' +
        '</div></div>' +
      '</div>' +

      '<div class="section-label">Tool Viability — Bristle / Abrasive Strength over Belt Uses</div>' +
      '<div class="chart-block">' +
        '<div class="chart-head">' +
          '<span class="chart-head-title">Viability Index per Belt Use</span>' +
          '<span class="chart-head-sub">Adapter change markers shown at recommended intervals</span>' +
        '</div>' +
        '<div class="chart-body">' +
          '<div class="chart-wrap"><canvas id="viabilityChart"></canvas></div>' +
          '<div class="chart-legend">' +
            '<div class="chart-legend-item"><div class="legend-dot" style="background:#FF1212"></div>Bristle Blaster® — adapter at ' + (TOOL_DATA.BB ? TOOL_DATA.BB.adapterInterval : 30) + '</div>' +
            '<div class="chart-legend-item"><div class="legend-dot" style="background:#9B59B6"></div>MBX® Metal Blaster — adapter at ' + (TOOL_DATA.MB ? TOOL_DATA.MB.adapterInterval : 60) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +

      '<div class="cta-row">' +
        (CTAS.orderUrl
          ? '<a class="btn-primary" href="' + CTAS.orderUrl + '" target="_blank" rel="noopener">' +
              (CTAS.orderLabel || 'Order Belts') +
              '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
            '</a>'
          : '') +
        (BELT_LINKS[toolCode]
          ? '<a class="btn-outline" href="' + BELT_LINKS[toolCode] + '" target="_blank" rel="noopener">' +
              'View ' + tool.name + ' Belts' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
            '</a>'
          : '') +
      '</div>' +
      '<div class="cta-row cta-row-utility">' +
        '<button class="btn-utility" onclick="downloadPdf()">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>' +
          'Save as PDF' +
        '</button>' +
        '<button class="btn-utility" id="mp-bs-copy-btn" onclick="copyShareLink()">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>' +
          'Copy link' +
        '</button>' +
        '<button class="btn-utility" onclick="resetSelector()">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 .49-3.5"></path></svg>' +
          'New Selection' +
        '</button>' +
      '</div>' +

      '<div class="support-strip">' +
        '<p class="support-label">Have questions or need a technical consult?</p>' +
        '<div class="support-links">' +
          (CTAS.supportEmail
            ? '<a href="mailto:' + CTAS.supportEmail + '" class="support-link">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>' +
                CTAS.supportEmail +
              '</a><span class="support-sep"></span>'
            : '') +
          (CTAS.distributorUrl
            ? '<a href="' + CTAS.distributorUrl + '" target="_blank" rel="noopener" class="support-link">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>' +
                (CTAS.distributorLabel || 'Find your distributor') +
              '</a><span class="support-sep"></span>'
            : '') +
          (CTAS.quoteUrl
            ? '<a href="' + CTAS.quoteUrl + '" target="_blank" rel="noopener" class="support-link support-link-cta">' +
                (CTAS.quoteLabel || 'Request a quote') +
                '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
              '</a>'
            : '') +
        '</div>' +
      '</div>' +

      '<div class="hs-quote-section">' +
        '<button class="hs-quote-header" onclick="toggleHsForm(this)" aria-expanded="false">' +
          '<span class="hs-quote-header-left">' +
            '<span class="hs-quote-title">' + (CTAS.hsFormTitle || 'Get a Quote for This Belt Package') + '</span>' +
            '<span class="hs-quote-subtitle">' + (CTAS.hsFormSubtitle || 'Your selection is included automatically — our team can prepare a tailored offer.') + '</span>' +
          '</span>' +
          '<span class="hs-toggle-icon">+</span>' +
        '</button>' +
        '<div class="hs-quote-body" id="mp-bs-hs-body">' +
          '<div class="hs-context-bar">' +
            '<span class="hs-context-item"><span class="hs-context-key">Standard</span> ' + stdLabel + (sspcLabel ? ' / ' + sspcLabel : '') + '</span>' +
            '<span class="hs-context-sep">·</span>' +
            '<span class="hs-context-item"><span class="hs-context-key">Substrate</span> ' + state.substrate + '</span>' +
            '<span class="hs-context-sep">·</span>' +
            '<span class="hs-context-item"><span class="hs-context-key">Grade</span> ' + gradeNum + ' (' + gradeMu + ')</span>' +
            '<span class="hs-context-sep">·</span>' +
            '<span class="hs-context-item"><span class="hs-context-key">Belts</span> ' + (bi23.article||b23) + ' · ' + (bi11.article||b11) + '</span>' +
          '</div>' +
          '<div id="mp-bs-hs-form"></div>' +
        '</div>' +
      '</div>';

    setTimeout(function () { buildChart(toolCode); }, 80);
  }

  // ─── CHART ───────────────────────────────────────────────────────────────
  function buildChart(activeKey) {
    var ctx = document.getElementById('viabilityChart');
    if (!ctx) return;
    if (mpChart) { mpChart.destroy(); mpChart = null; }

    var labels = [];
    for (var i = 1; i <= 70; i++) labels.push(i);

    // Register adapter-change marker plugin
    Chart.register({
      id: 'adapterMarkers',
      afterDraw: function (c) {
        var cx = c.ctx, xa = c.scales.x, ya = c.scales.y;
        var bbInt = TOOL_DATA.BB ? TOOL_DATA.BB.adapterInterval : 30;
        var mbInt = TOOL_DATA.MB ? TOOL_DATA.MB.adapterInterval : 60;
        var markers = [[bbInt-1,'#FF1212','BB ×'+bbInt],[mbInt-1,'#9B59B6','MBX ×'+mbInt]];
        markers.forEach(function (m) {
          var px = xa.getPixelForValue(m[0]);
          cx.save();
          cx.beginPath();
          cx.setLineDash([3, 4]);
          cx.strokeStyle = m[1] + '99';
          cx.lineWidth = 1;
          cx.moveTo(px, ya.top);
          cx.lineTo(px, ya.bottom);
          cx.stroke();
          cx.fillStyle = m[1];
          cx.font = 'bold 9px Archivo,sans-serif';
          cx.fillText(m[2], px + 3, ya.top + 14);
          cx.restore();
        });
      }
    });

    mpChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          { label:'Bristle Blaster®', data:VIABILITY.BB, borderColor:'#FF1212', backgroundColor:'rgba(255,18,18,0.06)', borderWidth: activeKey==='BB'?2.5:1.5, pointRadius:0, fill:false, tension:0.3 },
          { label:'MBX® Metal Blaster', data:VIABILITY.MB, borderColor:'#9B59B6', backgroundColor:'rgba(155,89,182,0.06)', borderWidth: activeKey==='MB'?2.5:1.5, pointRadius:0, fill:false, tension:0.3 }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { backgroundColor:'#0c0c0c', titleColor:'#fff', bodyColor:'#aaa', borderColor:'#333', borderWidth:1 }
        },
        scales: {
          x: { ticks:{ color:'#bbb', font:{size:10}, maxTicksLimit:12 }, grid:{ color:'rgba(0,0,0,0.05)' }, title:{ display:true, text:'Belt Uses', color:'#999', font:{size:11} } },
          y: { min:0, max:145, ticks:{ color:'#bbb', font:{size:10} }, grid:{ color:'rgba(0,0,0,0.05)' }, title:{ display:true, text:'Viability', color:'#999', font:{size:11} } }
        }
      }
    });
  }

  // ─── RESET ───────────────────────────────────────────────────────────────
  window.resetSelector = function () {
    state = { standard: null, substrate: null, grade: null };
    mpClearSession();
    document.querySelectorAll('.opt-card,.grade-btn,[id^="sub-"]').forEach(function (e) {
      e.classList.remove('selected');
    });
    var notice = document.getElementById('ssNotice');
    if (notice) notice.classList.remove('visible');
    showStep(1);
  };

  // ─── PDF DOWNLOAD ─────────────────────────────────────────────────────────
  window.downloadPdf = function () {
    var stdKey2 = state.standard;
    if (ALIASES[stdKey2]) stdKey2 = ALIASES[stdKey2];
    var rec = DB[stdKey2] && DB[stdKey2][state.substrate] && DB[stdKey2][state.substrate][state.grade];
    if (!rec) return;
    var toolCode = rec[0], b23 = rec[1], b11 = rec[2];
    var tool = TOOL_DATA[toolCode];
    var bi23 = BELT_INFO[b23] || {};
    var bi11 = BELT_INFO[b11] || {};
    var gradeNum = state.grade.split(' ')[1];
    var gradeMu  = state.grade.replace('Grade ' + gradeNum + ' ', '');
    var isStainless = (state.substrate === 'Stainless Steel' || state.substrate === 'Aluminium' || b23.indexOf('102') !== -1 || b23.indexOf('103') !== -1);
    var STD_LABEL  = { Sa2:'Sa 2', 'Sa2 ½':'Sa2 ½', Sa3:'Sa 3', St2:'St 2', St3:'St 3' };
    var SSPC_LABEL = { Sa2:'SSPC-SP6', 'Sa2 ½':'SSPC-SP10', Sa3:'SSPC-SP5', St2:'SSPC-SP2', St3:'SSPC-SP3' };
    var stdLabel2  = STD_LABEL[stdKey2]  || state.standard;
    var sspcLabel2 = SSPC_LABEL[stdKey2] || '';
    var today = new Date().toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' });
    var modelList = tool.models.map(function (m) {
      return '<tr><td class="mc">' + m.code + '</td><td>' + m.name + '</td></tr>';
    }).join('');
    var accelAlert = isStainless
      ? '<div class="al al-blue"><div class="alh">Stainless Steel Accelerator Bar Required</div><div class="alb">Use the dedicated Stainless Steel Accelerator Bar. Never mix CS and stainless bars — iron particle contamination will cause rouge and surface corrosion.</div></div>'
      : '<div class="al al-dark"><div class="alh">Carbon Steel Accelerator Bar</div><div class="alb">Use the Carbon Steel Accelerator Bar for CS belts. Keep dedicated bars per substrate and label clearly.</div></div>';

    var html = '<!DOCTYPE html><html><head><meta charset="UTF-8">' +
      '<title>Belt Selection — ' + stdLabel2 + ' · ' + state.substrate + '</title>' +
      (window.MP_ARCHIVO_URL ? '<style>@font-face{font-family:Archivo;font-weight:100 900;font-display:swap;src:url(' + window.MP_ARCHIVO_URL + ') format("woff2")}</style>' : '') +
      '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'body{font-family:Archivo,sans-serif;font-size:10.5pt;color:#0c0c0c;background:#fff}' +
        '@page{size:A4;margin:14mm 16mm 18mm}' +
        '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}' +
        '.hdr{background:#0c0c0c;color:#fff;padding:14px 20px;display:flex;align-items:center;justify-content:space-between}' +
        '.brand{font-size:19px;font-weight:800;letter-spacing:1px}.brand span{color:#FF1212}' +
        '.hdr-right{font-size:9px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,0.5)}' +
        '.banner{background:#FF1212;color:#fff;padding:14px 20px}' +
        '.banner-lbl{font-size:8.5px;font-weight:600;letter-spacing:2px;text-transform:uppercase;opacity:.8;margin-bottom:3px}' +
        '.banner-title{font-size:17px;font-weight:800;text-transform:uppercase;letter-spacing:.5px}' +
        '.banner-meta{font-size:9.5px;font-weight:300;margin-top:3px;opacity:.85}' +
        '.body{padding:18px 20px}' +
        '.sec{margin-bottom:16px}' +
        '.sec-h{font-size:8px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#888;padding-bottom:5px;border-bottom:1px solid #e0e0e0;margin-bottom:10px}' +
        '.g2{display:grid;grid-template-columns:1fr 1fr;gap:10px}' +
        '.g3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px}' +
        '.card{border:1px solid #e0e0e0;padding:11px 13px}' +
        '.card-h{font-size:8px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#aaa;margin-bottom:7px}' +
        '.tname{font-size:14px;font-weight:700;text-transform:uppercase;margin-bottom:4px}' +
        '.tdesc{font-size:9.5px;font-weight:300;color:#555;margin-bottom:8px;line-height:1.5}' +
        '.mt{width:100%;border-collapse:collapse}' +
        '.mt td{font-size:9.5px;font-weight:300;color:#555;padding:2px 0}.mc{font-weight:600;color:#0c0c0c;padding-right:10px;white-space:nowrap}' +
        '.belt-bar{height:4px;margin-bottom:8px}' +
        '.ba{font-size:17px;font-weight:800;color:#FF1212}' +
        '.bn{font-size:9.5px;color:#555;margin-top:2px}' +
        '.adapt-num{font-size:26px;font-weight:800;color:#FF1212;line-height:1}' +
        '.adapt-lbl{font-size:9.5px;font-weight:300;color:#777;margin-top:2px}' +
        '.al{border-left:3px solid #ccc;padding:7px 11px;background:#f5f5f5;margin-bottom:7px}' +
        '.al-red{border-left-color:#FF1212}.al-blue{border-left-color:#1565C0}.al-green{border-left-color:#2E7D32}.al-dark{border-left-color:#444}' +
        '.alh{font-size:8px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;margin-bottom:3px}' +
        '.alb{font-size:9.5px;font-weight:300;color:#555;line-height:1.5}' +
        '.ftr{border-top:1px solid #e0e0e0;padding:10px 20px;display:flex;justify-content:space-between;align-items:center}' +
        '.ftr-l{font-size:8.5px;color:#aaa}' +
        '.pill{display:inline-block;border:1px solid #ddd;padding:2px 6px;font-size:7.5px;font-weight:600;letter-spacing:1px;color:#aaa;margin-right:3px}' +
      '</style></head><body>' +
      '<div class="hdr"><div class="brand">MONTI<span>POWER</span></div><div class="hdr-right">Belt Selection Report</div></div>' +
      '<div class="banner">' +
        '<div class="banner-lbl">Belt Selection · EN ISO 8501-1 · SSPC-SP11</div>' +
        '<div class="banner-title">' + tool.name + '</div>' +
        '<div class="banner-meta">Standard: ' + stdLabel2 + (sspcLabel2 ? ' / ' + sspcLabel2 : '') + '  ·  Substrate: ' + state.substrate + '  ·  Profile: Grade ' + gradeNum + ' (' + gradeMu + ')</div>' +
      '</div>' +
      '<div class="body">' +
        '<div class="sec">' +
          '<div class="sec-h">Recommended Tool</div>' +
          '<div class="g2">' +
            '<div class="card">' +
              '<div class="card-h">Machine</div>' +
              '<div class="tname">' + tool.name + '</div>' +
              '<div class="tdesc">' + tool.desc + '</div>' +
              '<table class="mt"><tbody>' + modelList + '</tbody></table>' +
            '</div>' +
            '<div class="card">' +
              '<div class="card-h">Adapter Change Interval</div>' +
              '<div class="adapt-num">' + tool.adapterInterval + '</div>' +
              '<div class="adapt-lbl">belt uses per adapter — then replace</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="sec">' +
          '<div class="sec-h">Recommended Belts</div>' +
          '<div class="g2">' +
            '<div class="card">' +
              '<div class="belt-bar" style="background:' + (bi23.color||'#888') + '"></div>' +
              '<div class="card-h">23 mm</div>' +
              '<div class="ba">' + (bi23.article||b23) + '</div>' +
              '<div class="bn">' + (bi23.name||b23) + '</div>' +
            '</div>' +
            '<div class="card">' +
              '<div class="belt-bar" style="background:' + (bi11.color||'#888') + '"></div>' +
              '<div class="card-h">11 mm — Tight Spaces</div>' +
              '<div class="ba">' + (bi11.article||b11) + '</div>' +
              '<div class="bn">' + (bi11.name||b11) + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="sec">' +
          '<div class="sec-h">Maintenance Requirements</div>' +
          '<div class="al al-red"><div class="alh">Adapter Change — Every ' + tool.adapterInterval + ' Belts</div><div class="alb">Replace the adapter after every ' + tool.adapterInterval + ' belt uses. Worn adapters reduce performance, cause uneven wear, and can damage the drive unit.</div></div>' +
          '<div class="al al-dark"><div class="alh">Resharpening Stone — Extend Belt Life</div><div class="alb">Resharpen belts in 20 seconds with the resharpening stone. MBX® Pneumatic: use the reverse button for fast in-situ resharpening.</div></div>' +
          accelAlert +
          '<div class="al al-green"><div class="alh">Belt Recycling Programme</div><div class="alb">Montipower recycling bins recommended for used belt collection. Belts can be recycled, reducing CO₂ emissions.</div></div>' +
        '</div>' +
      '</div>' +
      '<div class="ftr">' +
        '<div class="ftr-l">Generated: ' + today + '  ·  montipower.com' + (CTAS.supportEmail ? '  ·  ' + CTAS.supportEmail : '') + '</div>' +
        '<div><span class="pill">ISO 8501-1</span><span class="pill">SSPC / AMPP</span><span class="pill">SSPC-SP11</span></div>' +
      '</div>' +
      '</body></html>';

    var w = window.open('', '_blank');
    if (!w) { alert('Please allow popups to download the PDF.'); return; }
    w.document.write(html);
    w.document.close();
    w.focus();
    setTimeout(function () { w.print(); }, 700);
  };

  // ─── COPY SHARE LINK ─────────────────────────────────────────────────────
  window.copyShareLink = function () {
    if (!state.grade || !state.substrate || !state.standard) return;
    var gradeNum = state.grade.split(' ')[1];
    var subEncoded = state.substrate.replace(/\s/g, '');
    var base = window.location.href.split('?')[0].split('#')[0];
    var url  = base + '?belt_std=' + encodeURIComponent(state.standard) +
                      '&belt_sub=' + subEncoded +
                      '&belt_grade=' + gradeNum;

    var btn = document.getElementById('mp-bs-copy-btn');
    function flash() {
      if (!btn) return;
      var svg = btn.querySelector('svg') ? btn.querySelector('svg').outerHTML : '';
      btn.innerHTML = svg + 'Copied!';
      btn.classList.add('btn-utility-success');
      setTimeout(function () {
        btn.innerHTML = svg + 'Copy link';
        btn.classList.remove('btn-utility-success');
      }, 2500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(flash).catch(function () { mpFallbackCopy(url); flash(); });
    } else { mpFallbackCopy(url); flash(); }
  };

  function mpFallbackCopy(text) {
    var el = document.createElement('textarea');
    el.value = text;
    el.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(el);
    el.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(el);
  }

  // ─── HUBSPOT QUOTE FORM ───────────────────────────────────────────────────
  window.toggleHsForm = function (btn) {
    // Walk up to the .hs-quote-section wrapper — that's where hs-quote-open is toggled
    var section = btn;
    while (section && !section.classList.contains('hs-quote-section')) {
      section = section.parentElement;
    }
    if (!section) return;
    var isOpen = section.classList.contains('hs-quote-open');
    section.classList.toggle('hs-quote-open');
    btn.setAttribute('aria-expanded', String(!isOpen));
    if (!isOpen) mpLoadHsForm();
  };

  function mpLoadHsForm() {
    var container = document.getElementById('mp-bs-hs-form');
    if (!container || container.dataset.loaded) return;
    container.dataset.loaded = '1';
    container.innerHTML = '<div style="padding:20px;text-align:center;font-size:12px;color:#aaa;font-family:Archivo,sans-serif;">Loading form…</div>';

    var stdKey3 = state.standard;
    if (ALIASES[stdKey3]) stdKey3 = ALIASES[stdKey3];
    var rec3 = DB[stdKey3] && DB[stdKey3][state.substrate] && DB[stdKey3][state.substrate][state.grade];

    function createForm() {
      container.innerHTML = '';
      window.hbspt.forms.create({
        portalId: HS_PORTAL_ID,
        formId:   HS_FORM_ID,
        target:   '#mp-bs-hs-form',
        onFormSubmitted: function ($form, data) {
          // inquiry auto-reply (theme.js → window.mpInquiryAck)
          try {
            var vals = (data && data.submissionValues) || {};
            var email = vals.email || ($form && $form.find && $form.find('input[name="email"]').val());
            var name = [vals.firstname, vals.lastname].filter(Boolean).join(' ');
            if (window.mpInquiryAck) window.mpInquiryAck({ email: email, name: name, form: 'belt-selector' });
          } catch (e) {}
        },
        onFormReady: function ($form) {
          // Pre-populate hidden fields if they exist in your HubSpot form
          var fields = {
            'belt_standard':     state.standard,
            'belt_substrate':    state.substrate,
            'belt_profile_grade': state.grade,
            'belt_article_23mm': rec3 ? ((BELT_INFO[rec3[1]] && BELT_INFO[rec3[1]].article) || rec3[1]) : '',
            'belt_article_11mm': rec3 ? ((BELT_INFO[rec3[2]] && BELT_INFO[rec3[2]].article) || rec3[2]) : '',
            'belt_tool':         rec3 ? TOOL_DATA[rec3[0]].name : ''
          };
          Object.keys(fields).forEach(function (name) {
            var input = $form.find('input[name="' + name + '"]');
            if (input.length) input.val(fields[name]).change();
          });
        }
      });
    }

    if (window.hbspt) {
      createForm();
    } else {
      var s = document.createElement('script');
      s.src = '//js.hsforms.net/forms/v2.js';
      s.charset = 'utf-8';
      s.onload = createForm;
      document.head.appendChild(s);
    }
  }

})();
